<div [ngStyle]="{ 'display' : navaidController.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <div class="fields__container__tabs">
    <div
      class="fields__container__tabs__item"
      (click)="activatePrimaryData()"
    >
      <a [ngClass]="primaryDataActive ? 'active' : ''" href="#" data-tab="1"
        >Primary Data</a
      >
    </div>
    <div
      class="fields__container__tabs__item"
      (click)="activateSecondaryData()"
    >
      <a
        [ngClass]="secondaryDataActive ? 'active' : ''"
        href="#"
        data-tab="2"
        >Secondary Data</a
      >
    </div>
    <div class="fields__container__tabs__item" (click)="activateSectorization()">
      <a [ngClass]="sectorizationActive ? 'active' : ''" href="#" data-tab="4"
        >Sectorization</a
      >
    </div>
    <div class="fields__container__tabs__item" (click)="activateScreeningAngles()">
      <a [ngClass]="screeningAnglesActive ? 'active' : ''" href="#" data-tab="4"
        >Actual Screening Angles</a
      >
    </div>
    <div
      class="fields__container__tabs__item"
      (click)="activateAssociations()"
    >
      <a
        [ngClass]="associationsActive ? 'active' : ''"
        href="#"
        data-tab="3"
        >Associations</a
      >
    </div>
    <div class="fields__container__tabs__item" (click)="activateNotes()">
      <a [ngClass]="notesActive ? 'active' : ''" href="#" data-tab="4"
        >Notes</a
      >
    </div>
  </div>
  <form autocomplete="off"
    #ngForm="ngForm" class="margin-tabs"
    [ngClass]="[primaryDataActive ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']"
    data-tab="1"
    id="navaidPrimaryForm"
    novalidate
  >
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Navaid Primary Data</h4>
          <span> </span>
        </div>
        <div class="input-fields">
          <div>
            <label for="">Identification</label>
            <input
              required
              maxlength="5"
              [(ngModel)]="navaidController.selectedNavaid.navaidid"
              type="text"
              name="navaidid"
              id="navaidid"
              alphaNumeric
              #id="ngModel"
            />
            <span class="error" *ngIf=" (id.dirty || id.touched) && id.errors?.nonAlphaNumeric">
              Only alphanumeric characters, hyphens and underscores are allowed.
            </span>
          </div>
          <div>
            <label for="">Name</label
            ><input
              required
              [(ngModel)]="navaidController.selectedNavaid.name"
              type="text"
              id="name"
              name="name"
              #navaidName="ngModel"
              alphaNumeric
            />
            <span class="error" *ngIf=" (navaidName.touched || navaidName.dirty)
            && navaidName.errors?.nonAlphaNumeric">
              Only alphanumeric characters, hyphens and underscores are allowed.
            </span>
          </div>
        </div>
        <div class="dropdown-fields">
          <div>
            <label for="">Type</label>
            <select
              [(ngModel)]="navaidController.selectedNavaid.navaidtype"
              name="navaidtype"
              id="navaidtype"
            >
              <option value="DME">DME</option>
              <option value="VOR_DME">VOR/DME</option>
              <option value="TACAN">TACAN</option>
              <option value="VORTAC">VORTAC</option>
              <option value="DME_ILS">DME/ILS</option>
              <option value="NDB">NDB</option>
              <option value="VOR">VOR</option>
            </select>
          </div>
        </div>
      </div>
      <div class="fields__block__section">
        <div class="title">
          <h4>Position</h4>
          <span> </span>
        </div>
        <div class="input-fields">
          <div>
            <label for="">Latitude</label>
            <div class="coordenates">
              <div>
                <select
                name="latCardinal"
                [(ngModel)]="navaidController.selectedNavaid.latLonDms.latitude.cardinal"
                (ngModelChange)="navaidController.selectedNavaid.latitude = navaidController.selectedNavaid.latLonDms.toLat()"
                style="width: auto; margin-right: 10px;">
                <option value="N">N</option>
                <option value="S">S</option>
              </select>
              <input
                type="number"
                id="latDegrees"
                name="latDegrees"
                [(ngModel)]="navaidController.selectedNavaid.latLonDms.latitude.degrees"
                (ngModelChange)="navaidController.selectedNavaid.latitude = navaidController.selectedNavaid.latLonDms.toLat();navaidController.isValueValid('lat_degrees', navaidController.selectedNavaid.latLonDms.latitude.degrees)"
                style="width: 16%"
                required
              /><span>º</span
              ><input
                type="number"
                id="latMinutes"
                name="latMinutes"
                [(ngModel)]="navaidController.selectedNavaid.latLonDms.latitude.minutes"
                (ngModelChange)="navaidController.selectedNavaid.latitude = navaidController.selectedNavaid.latLonDms.toLat();navaidController.isValueValid('lat_minutes', navaidController.selectedNavaid.latLonDms.latitude.minutes)"
                style="width: 16%"
                required
              /><span>´</span
              ><input
                type="number"
                id="latSeconds"
                name="latSeconds"
                [(ngModel)]="
                  navaidController.selectedNavaid.latLonDms.latitude.seconds
                "
                (ngModelChange)="
                  navaidController.selectedNavaid.latitude = navaidController.selectedNavaid.latLonDms.toLat();navaidController.isValueValid('lat_seconds', navaidController.selectedNavaid.latLonDms.latitude.seconds)
                "
                style="width: 16%"
                required
              />
              <span>´´</span>
              </div>

              <br /><input
                [(ngModel)]="navaidController.selectedNavaid.latitude"
                (ngModelChange)="
                  navaidController.selectedNavaid.latLonDms.fromLat(
                    navaidController.selectedNavaid.latitude
                  );navaidController.isValueValid('latitude', navaidController.selectedNavaid.latitude)
                "
                type="number"
                style="width: 64%; margin-top: 5px;margin-bottom: 5px;"
                id="latitude"
                name="latitude"
                required
              />
              <span>º</span>
              <span class="error" *ngIf="!navaidController.latitudeValid">
                The Latitude value must be an integer number defined between -90º and 90º.
              </span>
              <span class="error" *ngIf="!navaidController.lat_degreesValid">
                The Degrees value must be an integer number defined between 0º and 90º.
              </span>
              <span class="error" *ngIf="!navaidController.lat_minutesValid">
                The Minutes value must be an integer number defined between 0 and 59 minutes.
              </span>
              <span class="error" *ngIf="!navaidController.lat_secondsValid">
                The Seconds value must be defined between 0 and 59.99.
              </span>
            </div>
          </div>
          <div>
            <label for="">Longitude</label>
            <div class="coordenates">
              <select
              name="lonCardinal"
                [(ngModel)]="navaidController.selectedNavaid.latLonDms.longitude.cardinal"
                (ngModelChange)="navaidController.selectedNavaid.longitude = navaidController.selectedNavaid.latLonDms.toLon()"
                style="width: auto; margin-right: 10px;"
              >
                <option value="E" selected="selected">E</option>
                <option value="W">W</option></select
              ><input
                type="number"
                id="lonDegrees"
                name="lonDegrees"
                [(ngModel)]="
                  navaidController.selectedNavaid.latLonDms.longitude
                    .degrees
                "
                (ngModelChange)="
                  navaidController.selectedNavaid.longitude = navaidController.selectedNavaid.latLonDms.toLon();navaidController.isValueValid('lon_degrees', navaidController.selectedNavaid.latLonDms.longitude.degrees)
                "
                style="width: 15%"
                required
              /><span>º</span
              ><input
                type="number"
                id="lonMinutes"
                name="lonMinutes"
                [(ngModel)]="
                  navaidController.selectedNavaid.latLonDms.longitude
                    .minutes
                "
                (ngModelChange)="
                  navaidController.selectedNavaid.longitude = navaidController.selectedNavaid.latLonDms.toLon();navaidController.isValueValid('lon_minutes', navaidController.selectedNavaid.latLonDms.longitude.minutes)
                "
                style="width: 15%"
                required
              /><span>´</span
              ><input
                type="number"
                id="lonSeconds"
                name="lonSeconds"
                [(ngModel)]="
                  navaidController.selectedNavaid.latLonDms.longitude
                    .seconds
                "
                (ngModelChange)="
                  navaidController.selectedNavaid.longitude = navaidController.selectedNavaid.latLonDms.toLon();navaidController.isValueValid('lon_seconds', navaidController.selectedNavaid.latLonDms.longitude.seconds)
                "
                style="width: 15%"
                required
              /><span>´´</span><br /><input
                [(ngModel)]="navaidController.selectedNavaid.longitude"
                (ngModelChange)="
                  navaidController.selectedNavaid.latLonDms.fromLon(
                    navaidController.selectedNavaid.longitude
                  );navaidController.isValueValid('longitude', navaidController.selectedNavaid.longitude)
                "
                type="number"
                style="width: 64%; margin-top: 5px;margin-bottom: 5px;"
                id="longitude"
                name="longitude"
                required
              />
              <span>º</span>
              <span class="error" *ngIf="!navaidController.longitudeValid">
                The Longitude value must be an integer number defined between -90º and 90º.
              </span>
              <span class="error" *ngIf="!navaidController.lon_degreesValid">
                The Degrees value must be an integer number defined between 0º and 90º.
              </span>
              <span class="error" *ngIf="!navaidController.lon_minutesValid">
                The Minutes value must be an integer number defined between 0 and 59 minutes.
              </span>
              <span class="error" *ngIf="!navaidController.lon_secondsValid">
                The Seconds value must be defined between 0 and 59.99.
              </span>
            </div>
          </div>
          <div>
            <label for="">ICAO Country Code</label>
            <select [(ngModel)]="navaidController.selectedNavaid.icaocc" name="icaocc" id="icaocc" #icaocc='ngModel' required>
              <option *ngFor="let icaoCode of navaidController.icaoCountryCodes" [value]="icaoCode.icaocode">{{icaoCode.icaocode}}</option>
            </select>
            <div class="btn">
                <button
                type="submit"
                class="blue"
                (click)="navaidController.getIcaoContryCode();">Get ICAO Country Code
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Elevation</h4>
          <span> </span>
        </div>
        <div class="input-fields">
          <div>
            <label for="">Published Elevation</label>
            <div class="coordenates">
              <input
                #elevation="ngModel"
                [(ngModel)]="navaidController.selectedNavaid.elevation"
                (ngModelChange)="
                  navaidController.selectedNavaid.elevationMeters = pointsController.convertToMeters(
                    $event
                  ).toString()
                "
                type="number"
                style="width: 30%"
                id="elevation"
                name="elevation"
                required
              /><span>[ft]</span
              ><input
                id="elevationMeters"
                #elevationMeters="ngModel"
                name="elevationMeters"
                [(ngModel)]="
                  navaidController.selectedNavaid.elevationMeters
                "
                (ngModelChange)="
                  navaidController.selectedNavaid.elevation = pointsController.convertToFeet(
                    $event
                  ).toString()"
                type="number"
                style="width: 30%"
              /><span>[m]</span>
            </div>
          </div>
          <div>
            <label for="">Terrain Relative Elevation</label>
            <div class="coordenates">
              <input
                [(ngModel)]="
                  navaidController.selectedNavaid
                    .elevationRelativeTerrainFeet
                "
                (ngModelChange)="
                  navaidController.selectedNavaid.elevationRelativeTerrainMeters = pointsController.convertToMeters(
                    $event
                  )
                "
                id="terrainrelativelevationfeet"
                name="terrainrelativeelevationfeet"
                type="number"
                style="width: 30%"
              /><span>[ft]</span
              ><input
                [(ngModel)]="
                  navaidController.selectedNavaid
                    .elevationRelativeTerrainMeters
                "
                (ngModelChange)="
                  navaidController.selectedNavaid.elevationRelativeTerrainFeet = pointsController.convertToFeet(
                    $event
                  )
                "
                id="terrainrelativeelevationmeters"
                name="terrainrelativeelevationmeters"
                type="number"
                style="width: 30%"
              /><span>[m]</span>
            </div>
          </div>
          <div>
            <label for="">Antenna Height</label>
            <div class="coordenates">
              <input
                [(ngModel)]="navaidController.selectedNavaid.antheight"
                (ngModelChange)="
                  navaidController.selectedNavaid.antheightMeters = pointsController.convertToMeters(
                    $event
                  )
                "
                type="number"
                style="width: 30%"
                id="antheight"
                name="antheight"

                required
              /><span>[ft]</span
              ><input
                [(ngModel)]="
                  navaidController.selectedNavaid.antheightMeters
                "
                (ngModelChange)="
                  navaidController.selectedNavaid.antheight = pointsController.convertToFeet(
                    $event
                  )
                "
                type="number"
                style="width: 30%"
                id="antheightMeters"
                name="antheightMeters"

              /><span>[m]</span>
            </div>
          </div>
          <div>
            <label for="">Terrain Elevation</label>
            <div class="coordenates">
              <input
                [(ngModel)]="
                  navaidController.selectedNavaid.elevationTerrainFeet
                "
                (ngModelChange)="
                  navaidController.selectedNavaid.elevationTerrainMeters = pointsController.convertToMeters(
                    $event
                  )
                "
                id="terrainelevationfeet"
                name="terrainelevationfeet"
                type="number"
                style="width: 30%"
              /><span>[ft]</span
              ><input
                [(ngModel)]="
                  navaidController.selectedNavaid.elevationTerrainMeters
                "
                (ngModelChange)="
                  navaidController.selectedNavaid.elevationTerrainFeet = pointsController.convertToFeet(
                    $event
                  )
                "
                id="terrainelevationmeters"
                name="terrainelevationmeters"
                type="number"
                style="width: 30%"
              /><span>[m] </span>
            </div>
          </div>
        </div>
      </div>
      <div class="fields__block__section">
        <div class="title">
          <h4>DOC Parameters</h4>
          <span> </span>
        </div>
        <div class="input-fields">
          <div>
            <label for="">DOC</label>
            <div class="coordenates">
              <input
                [(ngModel)]="navaidController.selectedNavaid.doc"
                (ngModelChange)="navaidController.isValueValid('DOC', navaidController.selectedNavaid.doc)"
                type="number"
                #doc="ngModel"
                style="width: 64%"
                id="doc"
                name="doc"
                required
                minlength="1"
                maxlength="10"
              /><span>[NM]</span>
              <span class="error" *ngIf="!navaidController.docValid">
                The DOC value should be defined between 1 and {{ configurationService.currentConfiguration.facilityConfiguration.docMaxRange }}.
              </span>
            </div>
          </div>
          <div>
            <label for="">DOC Maximum Altitude</label>
            <div class="coordenates">
              <input
                [(ngModel)]="navaidController.selectedNavaid.maxaltitude"
                (ngModelChange)="
                  navaidController.selectedNavaid.maxaltitudeMeters = pointsController.convertToMeters(
                    $event
                  );navaidController.isValueValid('DOC_Maximum_Altitude', navaidController.selectedNavaid.maxaltitude)
                "
                type="number"
                style="width: 30%"
                id="maxaltitude"
                name="maxaltitude"
                required

              /><span>[ft]</span
              ><input
                [(ngModel)]="
                  navaidController.selectedNavaid.maxaltitudeMeters
                "
                (ngModelChange)="
                  navaidController.selectedNavaid.maxaltitude = pointsController.convertToFeet(
                    $event
                  )
                "
                type="text"
                style="width: 30%"
                id="maxaltitudeMeters"
                name="maxaltitudeMeters"

              /><span>[m]</span>
              <span class="error" *ngIf="!navaidController.docMaxAltitudeValid">
                The DOC Maximum Altitude value should be defined between 0 and {{this.configurationService.currentConfiguration.facilityConfiguration.docMaxAltitudeFT}} ft.
              </span>
            </div>
          </div>
          <div class="input-fields">

              <div class="coordenates" style="padding-left: 90px;">
                <input
                [(ngModel)]="this.navaidController.navaidUpdate"
                type="checkbox"
                id="infoupdate"
                name="infoupdate"
                />
                <label for="">Allow Update from EAD</label>
              <div style="margin-left: 12%;">
                <input
                  [(ngModel)]="published"
                  type="checkbox"
                  id="published"
                  name="published"
                />
                <label for="published">Published</label>
              </div>
              </div>
          </div>
          <div class="input-fields">
            <div class="btn" style="padding: 10px 0;">
              <a (click)="displaySectorizations()">Sectorization Display</a>
            </div>
            <div class="notes" *ngIf="this.getSectorizationMessage()" >The NavAid DOC contains sectorizations.</div>
            <div class="notes" *ngIf="this.getScreeningAnglesMessage()">Actual Screening Angles are defined.</div>
          </div>
      </div>
    </div>

    </div>
    <div class="fields__btn">
      <button
        type="submit"
        [ngClass]="ngForm.form.valid && checkFormValid() && navaidController.validDates && projectService.activeProject?.editable? 'blue' : 'gray'"
        (click)="saveNavaidValidation();"
        [disabled]="!ngForm.form.valid || !checkFormValid() || !navaidController.validDates || !projectService.activeProject?.editable"
      >
        Save
      </button>
      <a
        class="gray"
        href="#"
        type="reset"
        value="Cancel"
        (click)="tabsService.closeTab()"
        >Cancel</a
      >
    </div>
  </form>
  <form autocomplete="off"
    id="ngForm1"
    name="ngForm1"
    #ngForm1="ngForm"
    [ngClass]="[secondaryDataActive ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']">
    <div class="fields__block" [ngClass]="navaidController.selectedNavaid.navaidtype == 'VOR_DME' || navaidController.selectedNavaid.navaidtype == 'VORTAC'? 'one-third':''"><!-- add class .one-third to break in 3 columns-->
      <div class="fields__block__section">

        <div class="input-fields">
          <div style="flex-direction: column">
            <label
              [ngClass]="[
                colapsableLabelGeneralPlanning ? 'active' : '',
                colapsableLabelGeneralPlanning ? 'colapsable' : 'colapsable'
              ]"
              for=""
              (click)="colapsableLabelGeneralPlanningTrigger()"
              >General & Planning</label
            >
            <div
              [ngClass]="[
                colapsableDivGeneralPlanning ? 'active' : '',
                colapsableDivGeneralPlanning ? 'colapsable' : 'colapsable'
              ]"
            >
              <div>
                <label for="">ANSP</label
                ><input
                  type="text"
                  id="operator"
                  name="operator"
                  [(ngModel)]="navaidController.selectedNavaid.operator"
                  maxlength="50"
                />
              </div>
              <div>
                <label for="">Information Source</label
                ><input
                  type="text"
                  id="infosrce"
                  name="infosrce"
                  [(ngModel)]="navaidController.selectedNavaid.infosrce"
                  maxlength="50"
                />
              </div>
              <div>
                <label for="">Information Date</label
                ><input
                  [(ngModel)]="navaidController.selectedNavaid.infoupdate"
                  id="infoupdate"
                  type="date"
                  name="infoupdate"
                  (input)="this.navaidController.checkDateField('infoupdate',$event.target.value)"
                  />
                  <span class="error" *ngIf="this.navaidController.dateFieldsInvalid.get('infoupdate')">
                    Invalid Date: year cannot be after 2100 and not before 1950
                  </span>
              </div>
              <div>
                <label for="">Manufacturer</label
                ><input
                  type="text"
                  [(ngModel)]="navaidController.selectedNavaid.manufacturer"
                  id="manufacturer"
                  name="manufacturer"
                  maxlength="50"
                />
              </div>
              <div>
                <label for="">Model</label
                ><input
                  type="text"
                  [(ngModel)]="navaidController.selectedNavaid.model"
                  id="model"
                  name="model"
                  maxlength="50"
                />
              </div>
              <div>
                <label for="">Status</label
                ><select
                  [(ngModel)]="navaidController.selectedNavaid.operationalstatus"
                  name="operationalstatus"
                  id="operationalstatus"
                >
                  <option value="{{NavaidStatusEnum.OPERATIONAL.value}}">{{NavaidStatusEnum.OPERATIONAL.html}}</option>
                  <option value="{{NavaidStatusEnum.PLANNED.value}}">{{NavaidStatusEnum.PLANNED.html}}</option>
                  <option value="{{NavaidStatusEnum.DECOMMISSIONED.value}}">{{NavaidStatusEnum.DECOMMISSIONED.html}}</option>
                  <option value="{{NavaidStatusEnum.OUT_OF_SERVICE.value}}">{{NavaidStatusEnum.OUT_OF_SERVICE.html}}</option>
                </select>
              </div>
              <div>
                <label for="">Commissioning Date</label
                ><input
                  [(ngModel)]="navaidController.selectedNavaid.operationalsince"
                  type="date"
                  id="operationalsince"
                  name="operationalsince"
                  (input)="this.navaidController.checkDateField('operationalsince',$event.target.value)"
                />
                  <span class="error" *ngIf="this.navaidController.dateFieldsInvalid.get('operationalsince')">
                    Invalid Date: year cannot be after 2100 and not before 1950
                  </span>
              </div>
              <div>
                <label for="">Replacement Date</label
                ><input
                  [(ngModel)]="navaidController.selectedNavaid.dueforreplacement"
                  type="date"
                  id="dueforreplacement"
                  name="dueforreplacement"
                  (input)="this.navaidController.checkDateField('dueforreplacement',$event.target.value)"
                  />
                    <span class="error" *ngIf="this.navaidController.dateFieldsInvalid.get('dueforreplacement')">
                      Invalid Date: year cannot be after 2100 and not before 1950
                    </span>
                </div>
              <div>
                <label for="">Decommissioning Date</label
                ><input
                  type="date"
                  [(ngModel)]="navaidController.selectedNavaid.plannedremoval"
                  id="plannedremoval"
                  name="plannedremoval"
                  (input)="this.navaidController.checkDateField('plannedremoval',$event.target.value)"
                  />
                    <span class="error" *ngIf="this.navaidController.dateFieldsInvalid.get('plannedremoval')">
                      Invalid Date: year cannot be after 2100 and not before 1950
                    </span>
                </div>
              <div>
                <label for="">Last Flight Inspection</label
                ><input
                  [(ngModel)]="navaidController.selectedNavaid.lastinspection"
                  type="date"
                  id="lastinspection"
                  name="lastinspection"
                  (input)="this.navaidController.checkDateField('lastinspection',$event.target.value)"
                  />
                    <span class="error" *ngIf="this.navaidController.dateFieldsInvalid.get('lastinspection')">
                      Invalid Date: year cannot be after 2100 and not before 1950
                    </span>
                </div>
              <div>
                <label for="">Flight Inspection Interval</label
                ><input
                  class="inputNumber"
                  [(ngModel)]="navaidController.selectedNavaid.fligthinspectioninterval"
                  (ngModelChange)="navaidController.isValueValid('inpectioninterval', navaidController.selectedNavaid.fligthinspectioninterval)"
                  type="number"
                  id="inpectioninterval"
                  name="inpectioninterval"
                /><span>[months]</span>
                <span class="error" *ngIf="!navaidController.inpectionIntervalValid">
                  The Flight Inspection Interval value should be defined between 0 and 2.14748365e9 months.
                </span>
              </div>
              <div>
                <label for="">Planned Flight Inspection</label
                ><input
                  type="date"
                  [(ngModel)]="navaidController.selectedNavaid.plannedinspection"
                  id="plannedinspection"
                  name="plannedinspection"
                  (input)="this.navaidController.checkDateField('plannedinspection',$event.target.value)"
                  />
                    <span class="error" *ngIf="this.navaidController.dateFieldsInvalid.get('plannedinspection')">
                      Invalid Date: year cannot be after 2100 and not before 1950
                    </span>
                </div>
              <div style="flex-direction: column">
                <label [ngClass]="['colapsable', flightInpectionResportsActive?'active': '']" for="" (click)="flightInpectionResportsActive = !flightInpectionResportsActive"
                  >Flight Inspections Reports</label>
                  <div [ngClass]="['colapsable', flightInpectionResportsActive?'active': '','table-fields']">
                    <div>
                      <table>
                        <thead>
                          <tr>
                            <th scope="col">File Name</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let navaidfile of navaidController.selectedNavaid.navaidFiles; let i = index"  [class.highlighted]="navaidFileSelected == i" (click)="navaidFileSelected = i">
                            <td  *ngIf="navaidfile.fileType == 'flightInspectionReport'" (click)="navaidFileSelected = i">
                              <input type="text" name="flightInspection_{{i}}"[(ngModel)]="navaidfile.fileName">
                            </td>
                          </tr>
                        </tbody>

                      </table>
                    </div>
                    <div class="btn">
                      <input hidden type="file" #uploadNavaidFile (change)="navaidController.addNavaidFile($event.target.files[0],'flightInspectionReport')">
                      <button (click)="uploadNavaidFile.value='';uploadNavaidFile.click()">Add</button>
                      <button (click)="remove()">Remove</button>
                      <button (click)="downloadNavaidFile()">Download</button>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="fields__block" [ngClass]="navaidController.selectedNavaid.navaidtype == 'VOR_DME' || navaidController.selectedNavaid.navaidtype == 'VORTAC'? 'one-third':''"><!-- add class .one-third to break in 3 columns-->
      <div class="fields__block__section">
        <div class="input-fields">
          <div [ngStyle]="{'display': navaidController.selectedNavaid.navaidtype != 'VOR' && navaidController.selectedNavaid.navaidtype != 'NDB'? '' : 'none', 'flex-direction': 'column' }" >
            <label
              [ngClass]="[colapsableLabelDME_TACAN ? 'active' : '',colapsableLabelDME_TACAN ? 'colapsable' : 'colapsable']"
              for="" (click)="colapsableLabelDME_TACANTrigger()">DME/TACAN Data</label>
            <div
              [ngClass]="[
                colapsableDivDME_TACAN ? 'active' : '',
                colapsableDivDME_TACAN ? 'colapsable' : 'colapsable'
              ]">
              <div>
                <label for="">Classification</label
                ><select
                  [(ngModel)]="navaidController.selectedNavaid.dmetacanclass"
                  name="dmetacanclass"
                  id="dmetacanclass"
                >
                  <option value="ENR">ENR</option>
                  <option value="TMA">TMA</option>
                  <option value="ENR_TMA">ENR&TMA</option>
                </select>
              </div>
              <div>
                <input
                  type="checkbox"
                  [(ngModel)]="navaidController.selectedNavaid.meetingpost1989sarps"
                  id="meetingpost1989sarps"
                  name="meetingpost1989sarps"/>
                <label for="">Meeting Post 1989 SARPS</label>
              </div>
              <div>
                <label for="">VHF Tuning Frequency</label
                ><input type="number"
                id="vhfTunFreqInput" name="vhfTunFreqInput" [(ngModel)]="navaidController.selectedNavaid.vhfTunFreqInput" (change)="navaidController.defineFrequencies($event)"/><span>[MHz]</span>
              </div>
              <div>
                <label for="">UHF Downlink Frequency</label
                ><input type="number" id="uhfDownlinkFreqInput"
                name="uhfDownlinkFreqInput" [(ngModel)]="navaidController.selectedNavaid.uhfDownlinkFreqInput"/><span>[MHz]</span>
              </div>
              <div>
                <label for="">UHF Uplink Frequency</label
                ><input type="number" id="uhfUplinkFreqInput"
                name="uhfUplinkFreqInput" [(ngModel)]="navaidController.selectedNavaid.uhfUplinkFreqInput"/><span>[MHz]</span>
              </div>
              <div>
                <label for="">Channel</label
                ><input
                  type="text"
                  (change)="navaidController.defineFrequenciesFromChannel(navaidController.selectedNavaid.channel)"
                  [(ngModel)]="navaidController.selectedNavaid.channel"
                  id="channel"
                  name="channel"
                />
              </div>
              <div>
                <label for="">Bias</label
                ><input
                  type="number"
                  [(ngModel)]="navaidController.selectedNavaid.bias"
                  id="bias"
                  name="bias"
                /><span>[NM]</span>
              </div>
              <div>
                <label for="">MTBO</label
                ><input
                  type="number"
                  id="mtbo"
                  [(ngModel)]="navaidController.selectedNavaid.mtbo"
                  (ngModelChange)="navaidController.isValueValid('mtbo', navaidController.selectedNavaid.mtbo)"
                  min="1" max="100000"
                  name="mtbo"
                /><span>[hours]</span>
                <span class="error" *ngIf="!navaidController.mtboValid">
                  The MTBO value should be defined between 1 and 100000 hours.
                </span>
              </div>
              <div>
                <label for="">Transmitter Output Power</label
                ><input
                  type="number"
                  [(ngModel)]="navaidController.selectedNavaid.transmoutpower"
                  id="transmoutpower"
                  name="transmoutpower"
                /><span>[dBW]</span>
              </div>
              <div>
                <label for="">Cable Loss</label
                ><input
                  type="number"
                  [(ngModel)]="navaidController.selectedNavaid.cableloss"
                  id="cableloss"
                  name="cableloss"
                /><span>[dB]</span>
              </div>
              <div>
                <label for="">Declared EIRP</label
                ><input
                  type="number"
                  [(ngModel)]="navaidController.selectedNavaid.declaredeirp"
                  id="declaredeirp"
                  name="declaredeirp"
                /><span>[dBW]</span>
              </div>
              <div>
                <label for="">Antenna Type</label
                ><select type="text"
                [(ngModel)]="navaidController.selectedNavaid.antennatype"
                id="antennatype"
                name="antennatype"
                maxlength="50">
                  <option *ngFor="let value of getAntennaTypeValues()" [value]='value'>
                    {{value}}
                  </option>
                </select>
              </div>
              <div>
                <label for="">Cone of Silence</label
                ><input
                  type="number"
                  placeholder="5.0"
                  [(ngModel)]="navaidController.selectedNavaid.cone"
                  (ngModelChange)="navaidController.isValueValid('cone', navaidController.selectedNavaid.cone)"
                  id="cone"
                  value="5.0"
                  name="cone"
                  placeholder="Range 5-60"
                /><span>[deg]</span>
                <span class="error" *ngIf="!navaidController.coneValid">
                  The Cone of Silence value should be defined between 5 and {{this.configurationService.currentConfiguration.calculation.coneOfSilenceDefa}} degs.
                </span>
              </div>
              <div>
                <label for="">ARINC 424 FOM</label
                ><select
                  [(ngModel)]="navaidController.selectedNavaid.arinc424fom"
                  id="arinc424fom"
                  name="arinc424fom"
                >
                  <option value="TERMINAL_USE">0: DOC < 25[NM] - ALTITUDE < 12000[FT]</option>
                  <option value="LOW_ALTITUDE_USE">1: DOC < 40[NM] - ALTITUDE < 18000[FT]</option>
                  <option value="HIGH_ALTITUDE">2: DOC < 130[NM] - ALTITUDE < 60000[FT]</option>
                  <option value="EXTENDED_HIGH_ALTITUDE">3: DOC > 130[NM]</option>
                  <option value="NOT_INCLUDED">7: NOT INCLUDED</option>
                  <option value="OUT_OF_SERVICE">9: OUT OF SERVICE</option>
                </select>
              </div>
              <div>
                <label for="">Maximum Load</label
                ><input
                  type="number"
                  [(ngModel)]="navaidController.selectedNavaid.maxload"
                  id="maxload"
                  name="maxload"
                /><span>[ppps]</span>
              </div>
              <div>
                <label for="">Quiescent Squitter Rate</label
                ><input
                  type="number"
                  id="quiescentsquitterrate"
                  [(ngModel)]="navaidController.selectedNavaid.quiescentsquitterrate"
                  name="quiescentsquitterrate"
                /><span>[ppps]</span>
              </div>
            <div>
                <label for="">Antenna Model</label
                ><select
                  [(ngModel)]="navaidController.selectedNavaid.antennaModelName"
                  id="antennaModel"
                  name="antennaModel"
                >
                  <option [ngValue]="null">Not selected</option>
                  <option *ngFor="let model of antennaPatternService.antennaModels" [ngValue]="model.modelName">{{model.modelName}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="input-fields" [ngStyle]="{'display': navaidController.selectedNavaid.navaidtype == 'VOR'? '' : 'none'}">
          <div style="flex-direction: column">
            <label
              [ngClass]="[
                colapsableLabelVorInformation ? 'active' : '',
                colapsableLabelVorInformation ? 'colapsable' : 'colapsable'
              ]"
              for=""
              (click)="colapsableLabelVorInformationTrigger()"
              for=""
              >VOR Information</label
            >
            <div
              [ngClass]="[
                colapsableDivVorInformation ? 'active' : '',
                colapsableDivVorInformation ? 'colapsable' : 'colapsable'
              ]"
            >
            <div>
              <label for="">Type</label
              ><select
                [(ngModel)]="navaidController.selectedNavaid.vortype"
                name="vortype"
                id="vortype"
              >
                <option value="CONVENTIONAL">Conventional</option>
                <option value="DOPPLER">Doppler</option>
              </select>
            </div>
            <div>
              <label for="">RNAV Max Range</label>
              <input
                type="number"
                [(ngModel)]="navaidController.selectedNavaid.vordocmaxrange"
                id="vordocmaxrange"
                name="vordocmaxrange"
              /><span>[NM]</span>
              <span class="error" *ngIf="!navaidController.inpectionIntervalValid">
                The RNAV Max Range value should be defined between 1 and 500 NM.
              </span>
            </div>
          </div>
          </div>
        </div>
        <div class="input-fields" [ngStyle]="{'display': navaidController.selectedNavaid.navaidtype == 'NDB'? '' : 'none'}">
          <div style="flex-direction: column">
            <label
              [ngClass]="[
              colapsableLabelNDBInformation ? 'active' : '',
              colapsableLabelNDBInformation ? 'colapsable' : 'colapsable'
              ]"
              for=""
              (click)="colapsableLabelNDBInformationTrigger()"
              for=""
              >NDB Information</label
            >
            <div
              [ngClass]="[
                colapsableDivNDBInformation ? 'active' : '',
                colapsableDivNDBInformation ? 'colapsable' : 'colapsable'
              ]"
            >
            <div>
              <label for="">Frequency</label>
              <input
                type="number"
                [(ngModel)]="navaidController.selectedNavaid.ndbfrequency"
                (ngModelChange)="navaidController.isValueValid('ndbfrequency', navaidController.selectedNavaid.ndbfrequency)"
                id="ndbfrequency"
                name="ndbfrequency"
              /><span>[NM]</span>
              <span class="error" *ngIf="!navaidController.ndbFrequencyValid">
                The Frequency value should be defined between 190 and 1750 kHz.
              </span>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__block" [ngStyle]="{'display': navaidController.selectedNavaid.navaidtype != 'VOR_DME' && navaidController.selectedNavaid.navaidtype != 'VORTAC'? 'none' : ''}"
          [ngClass]="navaidController.selectedNavaid.navaidtype == 'VOR_DME' || navaidController.selectedNavaid.navaidtype == 'VORTAC'? 'one-third':''"><!-- add class .one-third to break in 3 columns-->
      <div class="fields__block__section">
        <div class="input-fields">
          <div [ngStyle]="{'display': navaidController.selectedNavaid.navaidtype != 'VOR_DME' && navaidController.selectedNavaid.navaidtype != 'VORTAC'? 'none' : '', 'flex-direction': 'column' }" >
            <label
              [ngClass]="[
                colapsableLabelVORSpecific ? 'active' : '',
                colapsableLabelVORSpecific ? 'colapsable' : 'colapsable'
              ]"
              for=""
              (click)="colapsableLabelVORSpecificTrigger()"
              for=""
              >VOR Specific Data</label
            >
            <div
              [ngClass]="[
                colapsableDivVORSpecific ? 'active' : '',
                colapsableDivVORSpecific ? 'colapsable' : 'colapsable'
              ]"
            >
              <div>
                <label for="">Type</label
                ><select
                  [(ngModel)]="navaidController.selectedNavaid.vortype"
                  name="vortype"
                  id="vortype"
                >
                  <option value="CONVENTIONAL">Conventional</option>
                  <option value="DOPPLER">Doppler</option>
                </select>
              </div>
              <div>
                <label for="">RNAV Max Range</label>
                <input
                  type="number"
                  [(ngModel)]="navaidController.selectedNavaid.vordocmaxrange"
                  (ngModelChange)="navaidController.isValueValid('vordocmaxrange', navaidController.selectedNavaid.vordocmaxrange)"
                  id="vordocmaxrange"
                  name="vordocmaxrange"
                /><span>[NM]</span>
                <span class="error" *ngIf="!navaidController.vorDocMaxRangeValid">
                  The RNAV Max Range value should be defined between 1 and 500 NM.
                </span>
              </div>
              <div>
                <label for="">VOR Latitude</label
                ><select class="cardinal" [(ngModel)]="navaidController.selectedNavaid.vorLatLonDms.latitude.cardinal"
                name="vorLatCardinal" style="width: auto; margin-right: 10px;" (change)="navaidController.selectedNavaid.vorlatitude = navaidController.selectedNavaid.vorLatLonDms.toLat()">
                  <option value="N">N</option>
                  <option value="S">S</option></select
                ><input [(ngModel)]="navaidController.selectedNavaid.vorLatLonDms.latitude.degrees" (change)="navaidController.selectedNavaid.vorlatitude =  navaidController.selectedNavaid.vorLatLonDms.toLat();" name="vorLatDegrees" type="number" style="width: 15%" /><span>º</span
                ><input [(ngModel)]="navaidController.selectedNavaid.vorLatLonDms.latitude.minutes" (change)="navaidController.selectedNavaid.vorlatitude =  navaidController.selectedNavaid.vorLatLonDms.toLat();" name="vorLatMinutes" type="number" style="width: 15%" /><span>´</span
                ><input [(ngModel)]="navaidController.selectedNavaid.vorLatLonDms.latitude.seconds" (change)="navaidController.selectedNavaid.vorlatitude =  navaidController.selectedNavaid.vorLatLonDms.toLat();" name="vorLatSeconds" type="number" style="width: 15%" /><span>"</span>
              </div>
              <div>
                <label for=""> </label
                ><input
                  [(ngModel)]="navaidController.selectedNavaid.vorlatitude"
                  (ngModelChange)="
                  navaidController.selectedNavaid.vorLatLonDms.fromLat(
                    navaidController.selectedNavaid.vorlatitude
                  );navaidController.isValueValid('vorlatitude', navaidController.selectedNavaid.vorlatitude)"
                  id="vorlatitude"
                  name="vorlatitude"
                  type="number"
                  style="width: 60%; margin-top: 5px"
                /><span>"</span>
                <span class="error" *ngIf="!navaidController.vorLatitudeValid">
                  The VOR Latitude value should be defined between -90 and 90 degrees.
                </span>
                <span class="error" *ngIf="!navaidController.vorLat_degreesValid">
                  The VOR Latitude Degrees value should be defined between 0 and 90 degrees.
                </span>
                <span class="error" *ngIf="!navaidController.vorLat_minutesValid">
                  The VOR Latitude Minutes should be defined between 0 and 59 minutes.
                </span>
                <span class="error" *ngIf="!navaidController.vorLat_secondsValid">
                  The VOR Latitude Seconds value should be defined between 0 and 59.99 seconds.
                </span>
              </div>
              <div>
                <label for="">VOR Longitude</label
                ><select class="cardinal" [(ngModel)]="navaidController.selectedNavaid.vorLatLonDms.longitude.cardinal" (change)="navaidController.selectedNavaid.vorlongitude = navaidController.selectedNavaid.vorLatLonDms.toLon()" name="vorLonCardinal" style="width: auto; margin-right: 10px;">
                  <option value="E">E</option>
                  <option value="W">W</option></select
                ><input [(ngModel)]="navaidController.selectedNavaid.vorLatLonDms.longitude.degrees" (change)="navaidController.selectedNavaid.vorlongitude = navaidController.selectedNavaid.vorLatLonDms.toLon();" name="vorLonDegrees" type="number" style="width: 15%" /><span>º</span
                ><input [(ngModel)]="navaidController.selectedNavaid.vorLatLonDms.longitude.minutes" (change)="navaidController.selectedNavaid.vorlongitude =  navaidController.selectedNavaid.vorLatLonDms.toLon();" name="vorLonMinutes" type="number" style="width: 15%" /><span>´</span
                ><input [(ngModel)]="navaidController.selectedNavaid.vorLatLonDms.longitude.seconds" (change)="navaidController.selectedNavaid.vorlongitude =  navaidController.selectedNavaid.vorLatLonDms.toLon();" name="vorLonSeconds" type="number" style="width: 15%" /><span>"</span>
              </div>
              <div>
                <label for=""> </label
                ><input
                  [(ngModel)]="navaidController.selectedNavaid.vorlongitude"
                  (ngModelChange)="
                  navaidController.selectedNavaid.vorLatLonDms.fromLat(
                    navaidController.selectedNavaid.vorlongitude
                  );navaidController.isValueValid('vorlatitude', navaidController.selectedNavaid.vorlongitude)"
                  id="vorlongitude"
                  name="vorlongitude"
                  type="number"
                  style="width: 60%; margin-top: 5px"
                /><span>"</span>
                <span class="error" *ngIf="!navaidController.vorLongitudeValid">
                  The VOR Longitude value should be defined between -180 and 180 degrees.
                </span>
                <span class="error" *ngIf="!navaidController.vorLon_degreesValid">
                  The VOR Longitude Degrees value should be defined between 0 and 180 degrees.
                </span>
                <span class="error" *ngIf="!navaidController.vorLon_minutesValid">
                  The VOR Longitude Minutes should be defined between 0 and 59 minutes.
                </span>
                <span class="error" *ngIf="!navaidController.vorLon_secondsValid">
                  The VOR Longitude Seconds value should be defined between 0 and 59.99 seconds.
                </span>
              </div>
              <div>
                <label for="">Offset Distance</label
                ><input
                  [(ngModel)]="navaidController.selectedNavaid.offsetdist"
                  type="number"
                  id="offsetdist"
                  name="offsetdist"
                /><span>[m]</span>
              </div>
              <div>
                <label for="">Status</label
                ><select
                  name="voroperstatus"
                  [(ngModel)]="navaidController.selectedNavaid.voroperstatus"
                  id="voroperstatus">
                  <option value="{{NavaidStatusEnum.OPERATIONAL.value}}">{{NavaidStatusEnum.OPERATIONAL.html}}</option>
                  <option value="{{NavaidStatusEnum.PLANNED.value}}">{{NavaidStatusEnum.PLANNED.html}}</option>
                  <option value="{{NavaidStatusEnum.DECOMMISSIONED.value}}">{{NavaidStatusEnum.DECOMMISSIONED.html}}</option>
                  <option value="{{NavaidStatusEnum.OUT_OF_SERVICE.value}}">{{NavaidStatusEnum.OUT_OF_SERVICE.html}}</option>
                </select>
              </div>
              <div>
                <label for="">Commissioning Date</label
                ><input
                  id="voroperationalsince"
                  [(ngModel)]="navaidController.selectedNavaid.voroperationalsince"
                  name="voroperationalsince"
                  type="date"
                  (input)="this.navaidController.checkDateField('voroperationalsince',$event.target.value)"
                  />
                    <span class="error" *ngIf="this.navaidController.dateFieldsInvalid.get('voroperationalsince')">
                      Invalid Date: year cannot be after 2100 and not before 1950
                    </span>
                </div>
              <div>
                <label for="">Replacement Date</label
                ><input
                  id="vordueforreplace"
                  [(ngModel)]="navaidController.selectedNavaid.vordueforreplace"
                  name="vordueforreplace"
                  type="date"
                  (input)="this.navaidController.checkDateField('vordueforreplace',$event.target.value)"
                  />
                    <span class="error" *ngIf="this.navaidController.dateFieldsInvalid.get('vordueforreplace')">
                      Invalid Date: year cannot be after 2100 and not before 1950
                    </span>
                </div>
              <div>
                <label for="">Decommissioning Date</label
                ><input
                  id="vorplannedremoval"
                  [(ngModel)]="navaidController.selectedNavaid.vorplannedremoval"
                  name="vorplannedremoval"
                  type="date"
                  (input)="this.navaidController.checkDateField('vorplannedremoval',$event.target.value)"
                  />
                    <span class="error" *ngIf="this.navaidController.dateFieldsInvalid.get('vorplannedremoval')">
                      Invalid Date: year cannot be after 2100 and not before 1950
                    </span>
                </div>
              <div>
                <label for="">Last Flight Inspection</label
                ><input
                  id="vorlastinsp"
                  [(ngModel)]="navaidController.selectedNavaid.vorlastinsp"
                  name="vorlastinsp"
                  type="date"
                  (input)="this.navaidController.checkDateField('vorlastinsp',$event.target.value)"
                  />
                    <span class="error" *ngIf="this.navaidController.dateFieldsInvalid.get('vorlastinsp')">
                      Invalid Date: year cannot be after 2100 and not before 1950
                    </span>
                </div>
              <div>
                <label for="">Flight Inspection Interval</label
                ><input
                  class="inputNumber"
                  type="number"
                  [(ngModel)]="navaidController.selectedNavaid.vorinpectioninterval"
                  (ngModelChange)="navaidController.isValueValid('vorinpectioninterval', navaidController.selectedNavaid.vorinpectioninterval)"
                  id="vorinpectioninterval"
                  name="vorinpectioninterval"
                /><span>[months]</span>
                <span class="error" *ngIf="!navaidController.vorInpectionIntervalValid">
                  The Flight Inspection Interval value should be defined between 0 and 2.14748365e9 months.
                </span>
              </div>
              <div>
                <label for="">Planned Flight Inspection</label
                ><input
                  type="date"
                  [(ngModel)]="navaidController.selectedNavaid.vorplannedinspection"
                  id="vorplannedinspection"
                  name="vorplannedinspection"
                  (input)="this.navaidController.checkDateField('vorplannedinspection',$event.target.value)"
                  />
                    <span class="error" *ngIf="this.navaidController.dateFieldsInvalid.get('vorplannedinspection')">
                      Invalid Date: year cannot be after 2100 and not before 1950
                    </span>
                </div>
              <div style="flex-direction: column">
                <label (click)="activeVorFlightInspectionReport = !activeVorFlightInspectionReport" [ngClass]="[activeVorFlightInspectionReport? 'active' : '', 'colapsable']" for=""
                  >Flight Inspections Reports</label
                >
                <div [ngClass]="['colapsable', activeVorFlightInspectionReport?'active': '','table-fields']">
                  <div>
                    <table>
                      <thead>
                        <tr>
                          <th scope="col">File Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let navaidfile of navaidController.selectedNavaid.navaidFiles;let i = index"
                          [class.highlighted]="navaidFileSelected == i" (click)="navaidFileSelected = i">
                          <td  *ngIf="navaidfile.fileType == 'vorFlightInspectionReports'" >
                            <input type="text" name="vorFlightInspection_{{i}}"[(ngModel)]="navaidfile.fileName">
                          </td>
                        </tr>
                      </tbody>

                    </table>
                  </div>
                  <div class="btn">
                    <input hidden type="file" #uploadVorFlightInspectionNavaidFile (change)="navaidController.addNavaidFile($event.target.files[0],'vorFlightInspectionReports')">
                    <button (click)="uploadVorFlightInspectionNavaidFile.value='';uploadVorFlightInspectionNavaidFile.click()">Add</button>
                    <button (click)="remove()">Remove</button>
                    <button (click)="downloadNavaidFile()">Download</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="fields__btn">
      <button href="#" type="submit" value="Save" [ngClass]="ngForm.form.valid && checkFormValid() && projectService.activeProject?.editable? 'blue' : 'gray'" (click)="saveNavaidValidation();" [disabled]="!ngForm.form.valid || !checkFormValid() || !projectService.activeProject?.editable">Save</button
      ><a class="gray" href="#" type="reset" value="Cancel" (click)="tabsService.closeTab()">Cancel</a>
    </div>
  </form>
  <form autocomplete="off"  [ngClass]="[associationsActive ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']" data-tab="3">
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="table-fields">
          <div style="flex-direction: column; margin-top: 10px">
            <label  [ngClass]="[
            colapsableLabelProceduresList ? 'active' : '',
            colapsableLabelProceduresList ? 'colapsable' : 'colapsable'
          ]"
          for=""
          (click)="colapsableProceduresList()"
              >Associated Procedures List</label
            >
            <div [ngClass]="[
            colapsableDivProceduresList ? 'active' : '',
            colapsableDivProceduresList ? 'colapsable' : 'colapsable'
          ]">
              <table>
                <thead>
                  <tr>
                    <th scope="col">Identifier</th>
                    <th scope="col">Name</th>
                    <th scope="col">Procedure Type</th>
                    <th scope="col">RNAV Performance Type</th>
                    <th scope="col">Reference Airport</th>
                    <th scope="col">Aircraft Speed [kts]</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let procedure of navaidController.selectedNavaid.associatedProcedures; let i = index" (click)="selectNavaidProcedure(procedure)"
                  [class.highlighted]="procedure.isselected">
                    <td>{{procedure.procedureid}}</td>
                    <td>{{procedure.name}}</td>
                    <td>{{procedure.proceduretype}}</td>
                    <td>{{procedure.rnavperformancetype}}</td>
                    <td>{{procedure.airport}}</td>
                    <td>{{procedure.aircraftspeed}}</td>
                  </tr>
                </tbody>
              </table>
              <div class="btn">
                <a (click)="addProcedureFromMap()">Add From Map</a>
                <a (click)="deleteSelectedProcedureFromList();">Delete From List</a>
                <a (click)="selectProceduresRows()">Show on Map</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="table-fields">
          <div style="flex-direction: column; margin-top: 10px">
            <label  [ngClass]="[
            colapsableLabelAirspaceBoundariesList ? 'active' : '',
            colapsableLabelAirspaceBoundariesList ? 'colapsable' : 'colapsable'
          ]"
          for=""
          (click)="colapsableAirspaceBoundariesList()"
              >Associated AirSpace Boundaries List</label
            >
            <div [ngClass]="[
            colapsableDivAirspaceBoundariesList ? 'active' : '',
            colapsableDivAirspaceBoundariesList ? 'colapsable' : 'colapsable'
          ]">
              <table>
                <thead>
                  <tr>
                    <th scope="col">Identifier</th>
                    <th scope="col">Name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let airspace of navaidController.selectedNavaid.associatedAirspaceBoundaries; let i = index" (click)="selectNavaidAirpsace(airspace)"
                  [class.highlighted]="airspace.isselected">
                    <td>{{airspace.airspaceboundaryid}}</td>
                    <td>{{airspace.name}}</td>
                  </tr>
                </tbody>
              </table>
              <div class="btn">
                <a (click)="addAirspaceFromMap()">Add From Map</a>
                <a (click)="deleteSelectedAirspaceFromList();">Delete From List</a>
                <a (click)="selectAirpsaceRows()">Show on Map</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__btn">
      <button href="#" type="submit" value="Save" [ngClass]="ngForm.form.valid && checkFormValid() && projectService.activeProject?.editable? 'blue' : 'gray'" (click)="saveNavaidValidation();" [disabled]="!ngForm.form.valid || !checkFormValid() || !projectService.activeProject?.editable">Save</button
      ><a class="gray" href="#" type="reset" value="Cancel" (click)="tabsService.closeTab()">Cancel</a>
    </div>
  </form>
  <form autocomplete="off"  [ngClass]="[notesActive ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']" data-tab="4">
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="input-fields">
          <div>
            <textarea
              [(ngModel)]="navaidController.selectedNavaid.notes"
              name="notes"
              cols="30"
              rows="10"
              id="notes"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__btn">
      <button href="#" type="submit" value="Save" [ngClass]="ngForm.form.valid && checkFormValid() && projectService.activeProject?.editable? 'blue' : 'gray'" (click)="saveNavaidValidation();" [disabled]="!ngForm.form.valid || !checkFormValid() || !projectService.activeProject?.editable">Save</button
        ><a class="gray" href="#" type="reset" value="Cancel" (click)="tabsService.closeTab()">Cancel</a>
    </div>
  </form>
  <form autocomplete="off"  [ngClass]="[sectorizationActive ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']" data-tab="4">
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="table-fields">
          <div>
            <div>
              <table>
                <thead>
                  <tr>
                    <th>DOC [NM]</th>
                    <th scope="col">Min Azimuth [deg]</th>
                    <th scope="col">Max Azimuth [deg]</th>
                    <th scope="col">Min Altitude [ft]</th>
                    <th scope="col">Max Altitude [ft]</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    mdbTableCol
                    *ngFor="
                      let el of navaidController.selectedNavaid
                        .sectorizations
                    "
                    (click)="el.isselected = !el.isselected"
                    [class.highlighted]="el.isselected"
                    [class.deleted]="el.istodelete"
                  >
                    <td>{{ el.doc }}</td>
                    <td>{{ el.minangle }}</td>
                    <td>{{ el.maxangle }}</td>
                    <td>{{ el.minaltitude }}</td>
                    <td>{{ el.maxaltitude }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="btn">
                <a (click)="addSectorizationTrigger()">Add Sector</a
                ><a (click)="deleteSectorizations()">Delete Sector</a
                ><a (click)="displaySectorizations()">Sectorization Display</a>
              </div>
            </div>
          </div>
        </div>
        <div class="input-fields">
          <div style="margin-top: 5px;">
            <input
              [(ngModel)]="navaidController.selectedNavaid.usesectorization"
              type="checkbox"
              id="usesectorization"
              name="usesectorization"/>
              <label for="">Use Sectorization</label>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__btn">
      <button href="#" type="submit" value="Save" [ngClass]="ngForm.form.valid && checkFormValid() && projectService.activeProject?.editable? 'blue' : 'gray'" (click)="saveNavaidValidation();" [disabled]="!ngForm.form.valid || !checkFormValid() || !projectService.activeProject?.editable">Save</button
        ><a class="gray" href="#" type="reset" value="Cancel" (click)="tabsService.closeTab()">Cancel</a>
    </div>
  </form>
  <form autocomplete="off"  [ngClass]="[screeningAnglesActive ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']" data-tab="4">
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="table-fields">
          <div>
            <div>
              <table>

                <thead>
                  <tr>
                    <th scope="col">Min Azimuth [deg]</th>
                    <th scope="col">Max Azimuth [deg]</th>
                    <th scope="col">Vertical Angle [deg]</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    mdbTableCol
                    *ngFor="
                      let el of navaidController.selectedNavaid
                        .actualScreeningAngle
                    "
                    (click)="el.isselected = !el.isselected"
                    [class.highlighted]="el.isselected"
                    [class.deleted]="el.istodelete"
                  >
                    <td>{{ el.minangle }}</td>
                    <td>{{ el.maxangle }}</td>
                    <td>{{ el.verticalangle }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="btn">
                <a (click)="addMinimumScreeningAngleTrigger()">Add</a
                ><a (click)="deleteAngle()">Delete</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__btn">
      <button href="#" type="submit" value="Save" [ngClass]="ngForm.form.valid && checkFormValid() && projectService.activeProject?.editable? 'blue' : 'gray'" (click)="saveNavaidValidation();" [disabled]="!ngForm.form.valid || !checkFormValid() || !projectService.activeProject?.editable">Save</button
        ><a class="gray" href="#" type="reset" value="Cancel" (click)="tabsService.closeTab()">Cancel</a>
    </div>
  </form>

</div>
